<template>
  <div class="tenant_option_info_area" id="tenant_option_info">
    <div class="edit_area_half">
      <checkBoxCannotChangedSection
        :titleLabel="passwordEnableFlagLabel"
        :nameValue="passwordEnableFlag"
      ></checkBoxCannotChangedSection>
      <inputCannotChangedSection
        :titleLabel="initLoginPasswordLabel"
        @inputUpdate="inputAddUpdate('initLoginPassword')"
      ></inputCannotChangedSection>
      <checkBoxCannotChangedSection
        :titleLabel="autoLogoutEnableFlagLabel"
        :nameValue="autoLogoutEnableFlag"
      ></checkBoxCannotChangedSection>
      <dropDownCannotChangedSection
        :titleLabel="autoLogoutSecondLabel"
        :initialValue="initialValue"
        @inputUpdate="inputAddUpdateAutoLogoutSecond('autoLogoutSecond')"
      ></dropDownCannotChangedSection>
      <checkBoxCannotChangedSection
        :titleLabel="ratingQuarityEnableFlagLabel"
        :nameValue="ratingQuarityEnableFlag"
        @inputUpdate="inputAddUpdate('ratingQuarityEnableFlag')"
      ></checkBoxCannotChangedSection>
      <checkBoxSection
        :titleLabel="pushNotificationEnableFlagLabel"
        :nameValue="pushNotificationEnableFlag"
        @inputUpdate="inputAddUpdate('pushNotificationEnableFlag')"
      ></checkBoxSection>
      <checkBoxSection
        :titleLabel="spEnableFlagLabel"
        :nameValue="spEnableFlag"
        @inputUpdate="inputAddUpdate('spEnableFlag')"
      ></checkBoxSection>
      <checkBoxBindSection
        :titleLabel="contactsEnableFlagLabel"
        :nameValue="contactsEnableFlag"
        :checked="false"
      ></checkBoxBindSection>
      <textAreaSection
        :titleLabel="remarksLabel"
        @inputUpdate="inputAddUpdate('remarks')"
      ></textAreaSection>
    </div>
    <div class="edit_area_half">
      <callAppCheckboxListSection
        :titleLabel="linkedApplication"
        :callAppList="callAppList"
      ></callAppCheckboxListSection>
    </div>
  </div>
</template>

<script>
import inputSection from './inputSection.vue'
import checkBoxSection from './checkBoxSection.vue'
import textAreaSection from './textAreaSection.vue'
import dropDownSection from './dropDownSection.vue'
import checkBoxBindSection from './checkBoxBindSection.vue'
import callAppCheckboxListSection from './callAppCheckboxListSection.vue'
import inputCannotChangedSection from './inputCannotChangedSection.vue'
import checkBoxCannotChangedSection from './checkBoxCannotChangedSection.vue'
import dropDownCannotChangedSection from './dropDownCannotChangedSection.vue'

export default {
  data() {
    return {
      passwordEnableFlagLabel: 'アプリパスワードの使用有無',
      initLoginPasswordLabel: 'アプリ初期パスワード',
      autoLogoutEnableFlagLabel: 'アプリ自動ログアウトの使用有無',
      autoLogoutSecondLabel: '自動ログアウト時間',
      ratingQuarityEnableFlagLabel: '評価管理機能の使用有無',
      pushNotificationEnableFlagLabel: 'push通知機能の使用有無',
      spEnableFlagLabel: 'サイレントpush通知機能の使用有無',
      contactsEnableFlagLabel: '標準電話帳連携機能の使用有無',
      remarksLabel: '備考',
      passwordLabel: '管理者パスワード',
      passwordEnableFlag: 'password_enable',
      autoLogoutEnableFlag: 'autoLogout_enable',
      ratingQuarityEnableFlag: 'rationgQuarity_enable',
      pushNotificationEnableFlag: 'pushNotification_enable',
      spEnableFlag: 'silentPush_enable',
      contactsEnableFlag: 'contacts_enable',
      isPasswordEnableFlag: true,
      isAutoLogoutEnableFlag: true,
      initialValue: 3600,
      linkedApplication: '連携アプリ'
    }
  },
  components: {
    inputSection,
    checkBoxSection,
    textAreaSection,
    dropDownSection,
    checkBoxBindSection,
    callAppCheckboxListSection,
    inputCannotChangedSection,
    checkBoxCannotChangedSection,
    dropDownCannotChangedSection
  },
  computed: {
    callAppList() {
      var callAppList = this.$store.state.corporations.callAppDefine
      callAppList[0].checked = true
      callAppList[0].isUsed = true
      return callAppList
    }
  },
  methods: {
    inputAddUpdate(e) {
      this.$store.dispatch('corporations/inputAddUpdate', {
        name: e,
        value: event.target.value
      })
    },
    inputAddUpdateAutoLogoutSecond(e) {
      this.initialValue = parseInt(event.target.value)
      this.$store.dispatch('corporations/inputAddUpdate', {
        name: e,
        value: event.target.value
      })
    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/masterPanel/masterView/CorporationView/corporationComponents/tenantOptionAddInfo.vue